const windowsOpen = (url, target = '_blank', features = 'noopener,noreferrer') => {
  const navigator = window;

  return navigator.open(url, target, features);
};

export default windowsOpen;
